module.exports = __webpack_public_path__ + "img/stall.3ab7b72e.svg";